import React, { useEffect } from "react";
import { useCustomPropertiesFilter } from "../../../state/FilterContext";
import { useArrayContext } from "../../../state/ArrayContext";
import { SourceItem } from "../../../shared/models/source-item.model";
import { PropertiesModel } from "../../../shared/models/metadata.model";

/***
 * Array source that returns the names of a filter for a custom property.
 * 
 * Params:
 *    property: the name of the custom property
 */
export const CustomPropertyFilterNames = React.memo(function CustomPropertyFilterNames(): React.ReactElement {
    const { setArray } = useArrayContext();
    const customProperties: PropertiesModel = useCustomPropertiesFilter();

    useEffect(() => {
        let names: Array<SourceItem> = [];
        names = Object.keys(customProperties || {}).map((name: string, ix: number) => {
            return {
                value: name,
                props: {},
                position: ix + 1,
            };
        }) || [];
        setArray(names);
    }, [customProperties, setArray]);

    return <></>;
});